// ============================================================================
// POLISH TRANSLATIONS - BIBLE TREASURES (SKARBY)
// ============================================================================
// Duchowe skarby i perły mądrości biblijnej

export const bibleTreasures = [
  {
    type: "perla_madrosci",
    content: "Kto chodzi z mądrymi, będzie mądry, ale towarzysz głupich będzie cierpiał",
    reference: "Przypowieści 13:20",
    category: "mądrość",
    strongNumbers: {
      "mądrymi": "H2450", // חכם (chakam) = mądry, inteligentny
      "chodzi": "H1980" // הלך (halak) = chodzić, żyć
    },
    reflection: "Znaczenie dobrego wyboru towarzyszy i mentorów"
  },
  {
    type: "skarb_boski",
    content: "Pan jest blisko tych, którzy mają złamane serce, i zbawia tych, którzy mają skruszonego ducha",
    reference: "Psalm 34:18",
    category: "pocieszenie",
    strongNumbers: {
      "blisko": "H7138", // קרוב (qarob) = bliski, niedaleki
      "złamane_serce": "H7665" // שבר (shabar) = łamać, niszczyć
    },
    reflection: "Bóg jest szczególnie blisko tych, którzy cierpią"
  },
  {
    type: "obietnica_boska",
    content: "Bo moje myśli nie są waszymi myślami ani wasze drogi moimi drogami, mówi Pan",
    reference: "Izajasz 55:8",
    category: "boska_tajemnica",
    strongNumbers: {
      "myśli": "H4284", // מחשבה (machashebah) = myśl, zamiar
      "drogi": "H1870" // דרך (derek) = droga, ścieżka
    },
    reflection: "Boska mądrość przewyższa nasze ludzkie zrozumienie"
  },
  {
    type: "zacheta",
    content: "Bądź mocny i odważny! Nie lękaj się i nie bój się, bo Pan, twój Bóg, jest z tobą",
    reference: "Jozue 1:9",
    category: "odwaga",
    strongNumbers: {
      "mocny": "H2388", // חזק (chazaq) = być silnym, trzymać się mocno
      "odważny": "H553" // אמץ (amats) = być odważnym
    },
    reflection: "Odwaga płynie z nieustannej obecności Boga"
  },
  {
    type: "tajemnica_wiary",
    content: "A wiara jest pewnością tego, czego się spodziewamy, dowodem tego, czego nie widzimy",
    reference: "Hebrajczyków 11:1",
    category: "wiara",
    strongNumbers: {
      "wiara": "G4102", // πίστις (pistis) = wiara, zaufanie
      "pewność": "G5287" // ὑπόστασις (hypostasis) = substancja, pewność
    },
    reflection: "Wiara wykracza poza to, co widoczne, i czyni realne to, co niewidzialne"
  },
  {
    type: "objawienie",
    content: "Ale kto by pił wodę, którą ja mu dam, nie będzie pragnął na wieki",
    reference: "Jan 4:14",
    category: "życie_duchowe",
    strongNumbers: {
      "woda": "G5204", // ὕδωρ (hydor) = woda
      "pragnął": "G1372" // διψάω (dipsao) = pragnąć
    },
    reflection: "Jezus oferuje wieczne duchowe zaspokojenie"
  },
  {
    type: "dziedzictwo_boskie",
    content: "A jeśli jesteśmy dziećmi, to i dziedzicami: dziedzicami Boga, a współdziedzicami Chrystusa",
    reference: "Rzymian 8:17",
    category: "tożsamość",
    strongNumbers: {
      "dziedzicami": "G2818", // κληρονόμος (kleronomos) = dziedzic
      "dziećmi": "G5043" // τέκνον (teknon) = dziecko, potomek
    },
    reflection: "Nasza boska tożsamość jako dzieci i dziedzice Boga"
  }
];

export default bibleTreasures;
